// extracted by mini-css-extract-plugin
export var content = "_2-3";
export var footer = "_2-4";
export var header = "_2-1";
export var panel = "_2-0";
export var tabsWrapper = "_2-2";